import React from 'react'
import palette from 'src/designSystem/variables/palette'
import { PillContainer } from './Pill.styles'
import { DarkenColor } from './Pill.helper'

export interface PillProps {
  label: React.ReactNode
  backgroundColor?: string
  useBorder?: boolean
  $fontColor?: string
  $height?: string
  $width?: string
  $size?: 'small' | 'medium' | 'large'
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const Pill = ({
  label,
  backgroundColor,
  useBorder,
  $height,
  $fontColor,
  $width,
  $size,
  onClick,
}: PillProps): JSX.Element => {
  return (
    <PillContainer
      onClick={onClick}
      style={{
        backgroundColor,
        height: $height,
        width: $width,
        border: useBorder
          ? `1px solid ${
              backgroundColor
                ? DarkenColor(backgroundColor || '#000', 40)
                : palette.neutral[100]
            }`
          : 'none',
        fontSize:
          $size === 'small' ? '12px' : $size === 'medium' ? '14px' : '16px',
        color: $fontColor || undefined,
      }}
    >
      {label}
    </PillContainer>
  )
}
